import { FolkShapeAttribute } from '../folk-shape-attribute';
FolkShapeAttribute.define();
export { FolkShapeAttribute };
//# sourceMappingURL=folk-shape-attribute.js.map